export const services = {

	twitter: {
		endpoint: 'https://twitter.com/share',
		data: {
			url: 'url',
			text: 'text',
			count: 'none'
		}
	},

	facebook: {
		endpoint: 'https://www.facebook.com/sharer/sharer.php',
		data: {
			url: 'u'
		}
	},

	linkedin: {
		endpoint: 'http://www.linkedin.com/shareArticle',
		data: {
			url: 'url',
			mini: 'true',
			title: 'title',
			source: 'Software Connect',
			summary: 'summary'
		}
	}

}

export const popupWindowOptions = [
	'width=600',
	'height=375',
	'directories=no',
	'location=no',
	'menubar=no',
	'status=no',
	'toolbar=no'
];


